import {bundlesMock} from '@Mocks/data/bundles.mock.js';

export class BundleTagHlp {
	constructor($log) {
		'ngInject';
		this.$log = $log;
	}

	/**
	 * Analyzes equipment-tag relationships from bundlesMock data
	 * @returns {Object} Analysis results with product mappings and tag suggestions
	 */
	analyzeEquipmentTags() {
		const productTagMap = new Map();
		const seriesTagMap = new Map();
		const brandTagMap = new Map();

		bundlesMock.forEach(bundle => {
			const {tags, products_list} = bundle;

			products_list.forEach(product => {
				const {product_number, series, brand_id, is_main_component} = product;

				// Map product numbers to tags
				if (!productTagMap.has(product_number)) {
					productTagMap.set(product_number, new Set());
				}
				tags.forEach(tag => productTagMap.get(product_number).add(tag));

				// Map series to tags (for main components)
				if (is_main_component && series) {
					if (!seriesTagMap.has(series)) {
						seriesTagMap.set(series, new Set());
					}
					tags.forEach(tag => seriesTagMap.get(series).add(tag));
				}

				// Map brand to tags
				if (brand_id) {
					if (!brandTagMap.has(brand_id)) {
						brandTagMap.set(brand_id, new Set());
					}
					tags.forEach(tag => brandTagMap.get(brand_id).add(tag));
				}
			});
		});

		return {
			productTagMap: this._convertMapToObject(productTagMap),
			seriesTagMap: this._convertMapToObject(seriesTagMap),
			brandTagMap: this._convertMapToObject(brandTagMap),
		};
	}

	/**
	 * Suggests tags for a replacement product
	 * @param {string} originalProductNumber - Original product number
	 * @param {string} replacementProductNumber - Replacement product number
	 * @returns {Array} Suggested tags for replacement
	 */
	suggestTagsForReplacement(originalProductNumber, replacementProductNumber) {
		const analysis = this.analyzeEquipmentTags();

		// Get original product tags
		const originalTags = analysis.productTagMap[originalProductNumber] || [];

		// Get replacement product tags if it exists in data
		const replacementTags = analysis.productTagMap[replacementProductNumber] || [];

		// Find common patterns
		const originalProduct = this._findProductInBundles(originalProductNumber);
		const replacementProduct = this._findProductInBundles(replacementProductNumber);

		if (!originalProduct) return replacementTags;

		// If replacement product exists in data, use its tags
		if (replacementProduct) return replacementTags;

		// Otherwise, suggest based on series/brand patterns
		const {series: origSeries, brand_id: origBrand} = originalProduct;
		const {series: replSeries, brand_id: replBrand} = replacementProduct || {};

		// Same series = keep all tags
		if (replSeries === origSeries) return originalTags;

		// Same brand = keep tier tags, remove promo/rebate tags
		if (replBrand === origBrand) {
			return originalTags.filter(
				tag => tag.key.includes('tier:') || (!tag.key.includes('promo:') && !tag.key.includes('tax_credit:'))
			);
		}

		// Different brand = only keep generic tags
		return originalTags.filter(tag => !tag.key.includes('tier:') && !tag.key.includes('promo:'));
	}

	_findProductInBundles(productNumber) {
		for (const bundle of bundlesMock) {
			const product = bundle.products_list.find(p => p.product_number === productNumber);
			if (product) return product;
		}
		return null;
	}

	_convertMapToObject(map) {
		const obj = {};
		map.forEach((value, key) => {
			obj[key] = Array.from(value);
		});
		return obj;
	}
}
//
let compMod = angular.module('mod.hlp.EquipmentTag', []).service('BundleTagHlp', BundleTagHlp);
export default (compMod = compMod.name);
